import React, { Component, useEffect, useState } from "react";
import styled from "styled-components";
import DataExplorerContainer from "./DataExplorer/dataExplorerContainer";

const Container = styled.div`
  width: 80%;
  margin:24px auto;
  .iReLkr .ReactTable * {
    text-align:left
  }
`;

export default function TrialConversionsExplorer() {
	const [searchBy, setSearchBy] = useState("dd"); // 'dd' for Daily, 'week' for Weekly
	const currentDateLabel = searchBy === "dd" ? "Daily" : "Weekly";
	const inverseDateLabel = searchBy === "dd" ? "Weekly" : "Daily";

	const handleChangeTimeFrame = () => {
		setSearchBy(searchBy === "dd" ? "week" : "dd");
	};

	const data = [{
		title: "Trial Conversions By Promo",
		query: "signUpsByPromo",
		explorer: "conversationsByPlatform",
		requestType: "trialConversionExplorer"
	},
	{
		title: "Trial Rejections Or Failures by Promo",
		query: "signUpsRejectionByPromo",
		explorer: "conversationsByBreakdown",
		requestType: "trialConversionExplorer"
	}
	]

	return (
		<Container>
			<h1>
				Trial Sign-ups Conversions
			</h1>
			<div>
				<label>Current Time Frame:</label>&nbsp;
				<span style={{ fontSize: "1.2rem" }}>{currentDateLabel}</span> &nbsp;
				<button onClick={handleChangeTimeFrame}>Change to {inverseDateLabel}</button>
			</div>
			<br />
			<div>
				{data.map((item, idx) => {
					// Ensure unique keys for components within the loop, especially when `searchBy` changes
					const dataExplorerKey = item.explorer + searchBy;
					return (
						<React.Fragment key={item.query + idx}>
							<h2>{(item.ignorePeriod ? "" : currentDateLabel)} {item.title}</h2>
							<DataExplorerContainer
								key={dataExplorerKey}
								date={searchBy}
								query={item.query}
								explorer={item.explorer}
								requestType={item.requestType}
								ignorePeriod={item.ignorePeriod || false}
							/>
							<hr />
						</React.Fragment>
					)
				})}
			</div>
		</Container>)
};